import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

// !COMPONENTS
import Layout from '@shared/components/layout'
import ChessInterestingReads from '@shared/components/chessComponents/chessIntrestingReads'
import ChessPlayers from '@shared/components/chessComponents/players'
import MyImage from '@shared/components/myImage'
import sPartner from '@assets/images/championTrophy/sPartner.png'
import sPartnerMweb from '@assets/images/championTrophy/sPartnerMweb.png'

import queryGraphql from '@shared/components/queryGraphql'
import { GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import styles from './style.module.scss'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import useWindowSize from '@shared/hooks/windowSize'
import ChampionTrophyHeader from '@shared/components/Champions-trophy/championHeader'
import ChampionsInfo from '@shared/components/Champions-trophy/championsInfo'
import ChampionTable from '@shared/components/Champions-trophy/championTable'
import VenueMweb from '@shared/components/Champions-trophy/venueMweb'
import BlogsNews from '@shared/components/olympics/blogsNews'
import ChampionMatches from '@shared/components/Champions-trophy/championMatches'
import ChampionsTimeline from '@shared/components/Champions-trophy/championsTimeline'
import ChampionsTeamsMweb from '@shared/components/Champions-trophy/championTeamsMweb'
import { GET_MAJOR_SERIES_DATA } from '@graphql/champions-trophy/champions'
import ReviveAds from '@shared/components/reviveAds'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

function ChampionTrophy({ allData, news, seoData, editorPick }) {
  const [width] = useWindowSize()

  const data = news?.listSeriesArticlesVideosFront?.oArticles
  const editorPickData = editorPick?.listSeriesArticlesVideosFront?.oArticles

  const info = allData?.data?.getMajorSeriesData?.aInfo
  const venues = allData?.data?.getMajorSeriesData?.aVenues
  const teams = allData?.data?.getMajorSeriesData?.aTeams
  const captainData = allData?.data?.getMajorSeriesData?.aCaptains
  const pointsData = allData?.data?.getMajorSeriesData?.aSeriesStandings
  const fixture = allData?.data?.getMajorSeriesData?.aFixtures

  function getMetaDetail() {
    return {
      oSeo: {
        sTitle: 'ICC Champions Trophy 2025:  All about the ICC Champions Trophy 2025 | Oneturf news',
        sDescription:
          'Get the latest updates on the ICC Champions Trophy 2025, including match schedules, team details, live scores, and expert analysis. Stay ahead with OneTurf News!',
        aKeywords: [
          'ICC Champions Trophy history, oneturf news, ICC Champions Trophy winners list, ICC Champions Trophy 2025, ICC Champions Trophy 2025 venue, ICC Champions Trophy 2025 schedule, ICC Champions Trophy 2025 start date, India vs Pakistan, PCB, BCCI.'
        ]
      }
    }
  }

  const { addTop, addLeft, mobSm } = reviveAdData

  return (
    <Layout data={getMetaDetail()}>
      <>
        <ChampionTrophyHeader />
        <Container>
          <div className="d-flex flex-column pt-4">
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={googleAddData?.addTop?.divId}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mb-4'}
              /> */}
              <ReviveAds {...addTop}/>
            </div>
            <div className="w-full d-flex d-xl-none justify-content-center mt-3">
              {/* <GoogleAds
                addId={googleAddData?.mobSm?.addId}
                divId={googleAddData?.mobSm?.divId}
                slotId={googleAddData?.mobSm?.slotId}
                dimension={googleAddData?.mobSm?.dimension}
                className={'mb-4'}
              /> */}
              <ReviveAds {...mobSm}/>
            </div>
            <Row className={`${styles.gap} mb-4`}>
              <Col xxl={3} className={`${styles.order} d-xxl-block d-none`}>
                {<ChampionsInfo info={info} venues={venues} />}
              </Col>
              <Col xl={8} xxl={6} className={`${styles.centerContent}`}>
                <ChampionMatches fixture={fixture} />
              </Col>
              <Col xl={4} xxl={3} className="common-sidebar mt-0">
                <ChampionTable points={pointsData} />
                {width > 767 && (
                  <>
                    <h4 className="font-bold">Streaming Partner</h4>
                    <a href="https://www.hotstar.com/" target="blank" className="d-flex my-3 justify-content-center w-100">
                      <MyImage src={sPartner} alt="Streaming Partner" />
                    </a>
                    <div className="w-full d-flex justify-content-center ">
                      {/* <GoogleAds
                        addId={googleAddData?.addLeft?.addId}
                        divId={googleAddData?.addLeft?.divId}
                        dimension={googleAddData?.addLeft?.dimension}
                        slotId={googleAddData?.addLeft?.slotId}
                        className={'mb-4'}
                      /> */}
                      <ReviveAds {...addLeft}/>
                    </div>
                  </>
                )}
              </Col>
            </Row>
            {width < 767 && (
              <>
                <div className="mb-4">
                  <h4 className="font-bold">Venues</h4>
                  <VenueMweb venues={venues} />
                </div>
                <a href="https://www.hotstar.com/" target="blank" className="d-flex justify-content-center w-100 mb-4">
                  <MyImage src={sPartnerMweb} />
                </a>
              </>
            )}

            {width > 767 && <ChessInterestingReads data={editorPickData?.aResults} />}
            {<ChampionsTimeline team={teams} />}
            {width < 767 && (
              <>
                <ChessInterestingReads data={editorPickData?.aResults} />
                <div className="w-full d-flex d-xl-none justify-content-center mt-3">
                  {/* <GoogleAds
                    addId={googleAddData?.mobSm?.addId}
                    divId={'div-gpt-ad-1726652608372-0'}
                    slotId={googleAddData?.mobSm?.slotId}
                    dimension={googleAddData?.mobSm?.dimension}
                    className={'mb-4'}
                  /> */}
                  <ReviveAds {...mobSm}/>
                </div>
                <ChampionsTeamsMweb team={teams} />
              </>
            )}
            <ChessPlayers isChampions captains={captainData} />
            {data?.aResults && <BlogsNews isChampion data={data?.aResults} />}
            {width < 767 && (
              // <GoogleAds
              //   addId={googleAddData?.mobLg?.addId}
              //   divId={googleAddData?.mobLg?.divId}
              //   dimension={googleAddData?.mobLg?.dimension}
              //   slotId={googleAddData?.mobLg?.slotId}
              //   className={'mt-0 mb-4'}
              // />
              <ReviveAds {...addLeft}/>
            )}
          </div>
        </Container>
      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')

    const seriesId = '676e345596e5d419bbccc7eb'
    const [editorPick, news] = await parallelCalls([
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 4,
          nSkip: 0,
          bEditorsPick: true,
          iSeriesId: seriesId,
          eType: 'n'
        }
      }),
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 12,
          nSkip: 0,
          iSeriesId: seriesId,
          eType: 'n'
        }
      })
    ])
    const allData = await queryGraphql(GET_MAJOR_SERIES_DATA, {
      input: { iSeriesId: seriesId }
    })
    return {
      props: {
        news: news || {},
        editorPick: editorPick || {},
        allData: allData || {}
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

ChampionTrophy.propTypes = {
  news: PropTypes.object,
  editorPick: PropTypes.object,
  seoData: PropTypes.object,
  allData: PropTypes.array,
  info: PropTypes.array,
  venues: PropTypes.array,
  teams: PropTypes.array
}

export default ChampionTrophy
